export { default } from './ControlBarTitle';
